module.exports = __webpack_public_path__ + "static/media/WI5.fc0325d9.png";